<template>
  <svg width="36" height="21" viewBox="0 0 36 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.00195 1.22668L1.00195 19.5335"
      stroke="#E10009"
      stroke-width="1.83068"
      stroke-linecap="round"
    />
    <g clip-path="url(#clip0_1_130756)">
      <path
        d="M19.1925 9.57141C18.9783 9.78595 18.8579 10.0768 18.8579 10.38C18.8579 10.6832 18.9783 10.974 19.1925 11.1885L23.5068 15.5051C23.7215 15.7197 24.0126 15.8403 24.3161 15.8403C24.6197 15.8403 24.9108 15.7197 25.1255 15.5051C25.3401 15.2905 25.4607 14.9993 25.4607 14.6958C25.4607 14.3922 25.3401 14.1011 25.1255 13.8865L22.7639 11.5241L31.5626 11.5241C31.866 11.5241 32.1571 11.4036 32.3716 11.189C32.5862 10.9744 32.7068 10.6834 32.7068 10.38C32.7068 10.0765 32.5862 9.78549 32.3716 9.57091C32.1571 9.35634 31.866 9.23579 31.5626 9.23579L22.7639 9.23579L25.1255 6.87421C25.2317 6.76793 25.316 6.64176 25.3736 6.5029C25.4311 6.36404 25.4607 6.21521 25.4607 6.0649C25.4607 5.9146 25.4311 5.76577 25.3736 5.6269C25.316 5.48804 25.2317 5.36187 25.1255 5.25559C25.0192 5.14931 24.893 5.065 24.7541 5.00748C24.6153 4.94997 24.4664 4.92036 24.3161 4.92036C24.1658 4.92036 24.017 4.94997 23.8781 5.00748C23.7393 5.065 23.6131 5.14931 23.5068 5.25559L19.1925 9.57141Z"
        fill="#E10009"
      />
    </g>
    <g clip-path="url(#clip1_1_130756)">
      <path
        d="M16.8104 9.57141C17.0247 9.78595 17.145 10.0768 17.145 10.38C17.145 10.6832 17.0247 10.974 16.8104 11.1885L12.4961 15.5051C12.2815 15.7197 11.9903 15.8403 11.6868 15.8403C11.3832 15.8403 11.0921 15.7197 10.8775 15.5051C10.6628 15.2905 10.5422 14.9993 10.5422 14.6958C10.5422 14.3922 10.6628 14.1011 10.8775 13.8865L13.2391 11.5241L4.44035 11.5241C4.1369 11.5241 3.84587 11.4036 3.6313 11.189C3.41672 10.9744 3.29618 10.6834 3.29618 10.38C3.29618 10.0765 3.41672 9.78549 3.6313 9.57091C3.84587 9.35634 4.1369 9.23579 4.44035 9.23579L13.2391 9.23579L10.8775 6.87421C10.7712 6.76793 10.6869 6.64176 10.6294 6.5029C10.5719 6.36404 10.5422 6.21521 10.5422 6.0649C10.5422 5.9146 10.5719 5.76577 10.6294 5.6269C10.6869 5.48804 10.7712 5.36187 10.8775 5.25559C10.9838 5.14931 11.1099 5.065 11.2488 5.00748C11.3877 4.94997 11.5365 4.92036 11.6868 4.92036C11.8371 4.92036 11.9859 4.94997 12.1248 5.00748C12.2636 5.065 12.3898 5.14931 12.4961 5.25559L16.8104 9.57141Z"
        fill="#E10009"
      />
    </g>
    <path
      d="M35.0005 1.22668L35.0005 19.5335"
      stroke="#E10009"
      stroke-width="1.83068"
      stroke-linecap="round"
    />
    <defs>
      <clipPath id="clip0_1_130756">
        <rect
          width="18.3068"
          height="18.3068"
          fill="white"
          transform="translate(16.6938 19.5334) rotate(-90)"
        />
      </clipPath>
      <clipPath id="clip1_1_130756">
        <rect
          width="18.3068"
          height="18.3068"
          fill="white"
          transform="matrix(0 -1 -1 4.37114e-08 19.3091 19.5334)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'CollapsIcon'
}
</script>
